import type React from 'react';

import styles from './styles';
import { Typography } from '@cobliteam/ui/components';

import { format } from '@cobliteam/utils/date';

import { useGetMediaView } from '@cobliteam/hooks/src/useCamera/useCameraMedia';

import { CircleDivider, ContentLoader, DriversCbIcon, HintPopup, VehicleGroupIcon } from '@cobliteam/base-components';

import Icon from '@cobliteam/ui/icons';

import useMediaStore from '../../../../store/zustand/useMediaStore';

export interface MediaDialogDriverInfoProps {
  isFetchingMediaRows?: boolean;
}

const MediaDialogDriverInfo: React.FC<MediaDialogDriverInfoProps> = ({ isFetchingMediaRows }) => {
  const mediaViewId = useMediaStore((state) => state.mediaViewId);

  const { data: mediaView } = useGetMediaView(mediaViewId);

  const mediaData = mediaView?.mediaInfo;

  if (!mediaData || isFetchingMediaRows) {
    return (
      <div className='flex space-x-2 p-5 align-middle text-gray-dark'>
        <div className='flex space-x-2'>
          <DriversCbIcon />
          <ContentLoader key={0} width={100} height={19}>
            <rect x='0' y='0' width='100' height='19' />
          </ContentLoader>
        </div>
        <CircleDivider />
        <div className='flex space-x-2'>
          <Icon name='car-front' />
          <ContentLoader key={0} width={100} height={19}>
            <rect x='0' y='0' width='100' height='19' />
          </ContentLoader>
        </div>
        <CircleDivider />
        <div className='flex space-x-2'>
          <VehicleGroupIcon />
          <ContentLoader key={0} width={100} height={19}>
            <rect x='0' y='0' width='100' height='19' />
          </ContentLoader>
        </div>
        <CircleDivider />
        <div className='flex space-x-2'>
          <Icon name='calendar-days' />
          <ContentLoader key={0} width={100} height={19}>
            <rect x='0' y='0' width='100' height='19' />
          </ContentLoader>
        </div>
      </div>
    );
  }

  const { driverName = 'Sem Motorista Associado', licensePlate = 'Sem placa', group = 'Sem grupo', driverFaceCluster, timestamp } = mediaData;
  const formatDate = format(timestamp, 'dd MMM yyyy HH:mm:ss');

  const getDriverSpan = () => {
    if (driverFaceCluster?.driver?.name) {
      return (
        <div className={styles.alignIcons}>
          <HintPopup title='Com identificação facial ' placement='top' arrow>
            <div className={styles.faceRecognitionIcon}>
              <Icon name='scan-face' />
            </div>
          </HintPopup>
          <Typography variant='description-title' color='secondary'>
            {driverFaceCluster.driver.name}
          </Typography>
        </div>
      );
    }

    return (
      <div className='flex space-x-2 align-middle text-gray-dark'>
        <DriversCbIcon />
        <Typography variant='description-title' color='secondary'>
          {driverName ?? 'Sem Motorista Associado'}
        </Typography>
      </div>
    );
  };

  return (
    <div className='flex space-x-2 p-5 align-middle text-gray-dark'>
      {getDriverSpan()}
      <CircleDivider />
      <div className='flex space-x-2'>
        <Icon name='car-front' />
        <Typography variant='description-title' color='secondary'>
          {licensePlate}
        </Typography>
      </div>
      <CircleDivider />
      <div className='flex space-x-2'>
        <VehicleGroupIcon />
        <Typography variant='description-title' color='secondary'>
          {group}
        </Typography>
      </div>
      <CircleDivider />
      <div className='flex space-x-2'>
        <Icon name='calendar-days' />
        <Typography variant='description-title' color='secondary'>
          {formatDate}
        </Typography>
      </div>
    </div>
  );
};

export default MediaDialogDriverInfo;
